import { clearInputField } from '../../helpers';

export const setupFrequentInvestorFields = ($form) => {
  const $frequentInvestorRadio = $('#frequent_investor_buttons input[type=radio]', $form);
  const $typeOfTransactionsField = $('#type_of_transactions_field', $form);

  $frequentInvestorRadio.on('change', (e) => {
    if (e.target.checked && e.target.value === 'true') {
      $typeOfTransactionsField.removeClass('d-none');
    } else {
      $typeOfTransactionsField.addClass('d-none');
      $('input', $typeOfTransactionsField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
};

export const setupManagedCreditInstitutionFields = ($form) => {
  const $managedCreditInstitution = $('#managed_credit_institution_buttons input[type=radio]', $form);
  const $managedCreditInstitutionFields = $('#managed_credit_institution_fields', $form);

  $managedCreditInstitution.on('change', (e) => {
    if (e.target.checked && e.target.value === 'true') {
      $managedCreditInstitutionFields.removeClass('d-none');
    } else {
      $managedCreditInstitutionFields.addClass('d-none');
      $('input', $managedCreditInstitutionFields).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
};

export const setupWorkedInCreditInstitutionFields = ($form) => {
  const $workedInCreditInstitution = $('#worked_in_credit_institution_buttons input[type=radio]', $form);
  const $workedInCreditInstitutionFields = $('#worked_in_credit_institution_fields', $form);

  $workedInCreditInstitution.on('change', (e) => {
    if (e.target.checked && e.target.value === 'true') {
      $workedInCreditInstitutionFields.removeClass('d-none');
    } else {
      $workedInCreditInstitutionFields.addClass('d-none');
      $('input', $workedInCreditInstitutionFields).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
};

export const setupInvestmentsInUnlicensedUndertakingsFields = ($form) => {
  const $investmentsInUnlicensedUndertakings =
    $('#investments_in_unlicensed_undertakings_buttons input[type=radio]', $form);
  const $investmentsInUnlicensedUndertakingsDescriptionField =
    $('#investments_in_unlicensed_undertakings_description_field', $form);

  $investmentsInUnlicensedUndertakings.on('change', (e) => {
    if (e.target.checked && e.target.value === 'true') {
      $investmentsInUnlicensedUndertakingsDescriptionField.removeClass('d-none');
    } else {
      $investmentsInUnlicensedUndertakingsDescriptionField.addClass('d-none');
      $('input', $investmentsInUnlicensedUndertakingsDescriptionField).each((_, inputElement) => {
        clearInputField(inputElement);
      });
    }
  });
};
